import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Brain, Moon, Sun, History, Home, Settings } from 'lucide-react';
import { useDarkMode } from '../hooks/useDarkMode';

export const Header: React.FC = () => {
  const { darkMode, toggleDarkMode } = useDarkMode();
  const location = useLocation();

  return (
    <header className="mb-12">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-primary-500 to-secondary-500 rounded-2xl blur-lg opacity-30 animate-pulse-glow"></div>
            <div className="relative bg-gradient-to-r from-primary-500 to-secondary-500 p-3 rounded-2xl">
              <Brain className="w-8 h-8 text-white" />
            </div>
          </div>
          <div>
            <h1 className="text-4xl font-bold gradient-text">CallOS</h1>
            <p className="text-gray-600 dark:text-gray-300 text-lg">
              Analizator transkryptów sprzedażowych oparty na AI
            </p>
          </div>
        </div>

        <div className="flex items-center space-x-3">
          {/* Navigation Links */}
          {location.pathname !== '/' && (
            <Link
              to="/"
              className="p-3 rounded-xl glass-card hover:bg-white/20 dark:hover:bg-white/10 
                         transition-all duration-200 group"
              title="Nowa analiza"
            >
              <Home className="w-6 h-6 text-primary-600 dark:text-primary-400 group-hover:scale-110 transition-transform duration-300" />
            </Link>
          )}
          
          {location.pathname !== '/history' && (
            <Link
              to="/history"
              className="p-3 rounded-xl glass-card hover:bg-white/20 dark:hover:bg-white/10 
                         transition-all duration-200 group"
              title="Historia analiz"
            >
              <History className="w-6 h-6 text-primary-600 dark:text-primary-400 group-hover:scale-110 transition-transform duration-300" />
            </Link>
          )}
          
          {location.pathname !== '/settings' && (
            <Link
              to="/settings"
              className="p-3 rounded-xl glass-card hover:bg-white/20 dark:hover:bg-white/10 
                         transition-all duration-200 group"
              title="Ustawienia organizacji"
            >
              <Settings className="w-6 h-6 text-primary-600 dark:text-primary-400 group-hover:scale-110 transition-transform duration-300" />
            </Link>
          )}

          {/* Dark Mode Toggle */}
          <button
            onClick={toggleDarkMode}
            className="p-3 rounded-xl glass-card hover:bg-white/20 dark:hover:bg-white/10 
                       transition-all duration-200 group"
            aria-label={darkMode ? 'Przełącz na tryb jasny' : 'Przełącz na tryb ciemny'}
          >
            {darkMode ? (
              <Sun className="w-6 h-6 text-accent-500 group-hover:rotate-180 transition-transform duration-300" />
            ) : (
              <Moon className="w-6 h-6 text-primary-600 group-hover:rotate-12 transition-transform duration-300" />
            )}
          </button>
        </div>
      </div>
    </header>
  );
};